import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { useDropzone } from 'react-dropzone';
import { Grid, Typography, colors, } from '@material-ui/core';
import { NEUTRAL } from 'constants/filesStatus'

const useStyles = makeStyles((theme) => ({
  imageGrid: {
    border: `1px dashed ${theme.palette.divider}`,
    padding: theme.spacing(6),
    outline: 'none',
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: colors.grey[50],
      opacity: 0.5,
      cursor: 'pointer'
    }
  },
  image: {
    width: 100,
  },
}));

const AddImage = props => {
  const { files, handleImagesChange, isMulti, } = props;

  const classes = useStyles();

  const handleDrop = (acceptedFiles) => {
    handleImagesChange([ ...files, ...acceptedFiles]);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: handleDrop
  });

  if (!isMulti) {
    const nbActiveFiles = files.reduce((acc, file) => {
      if (typeof file.name === 'string' || (typeof file.name !== 'string' && file.status === NEUTRAL)) {
        return acc + 1
      }
      return acc
    }, 0)

    if (nbActiveFiles === 1) {
      return null
    }
  }

  return (
    <Grid item md={4} sm={12}>
      <div
        className={clsx({
          [classes.imageGrid]: true,
          [classes.dropZone]: true,
          [classes.dragActive]: isDragActive
        })}
        {...getRootProps()}
      >
        <input {...getInputProps()} />
        <div>
          <img
            alt="Add"
            className={classes.image}
            src="/images/undraw_add_file2_gvbb.svg"
          />
        </div>
        <div>
          <Typography
            gutterBottom
            variant="h6"
          >
            Add Image
          </Typography>
        </div>
      </div>
    </Grid>
  );
};

AddImage.propTypes = {
  isMulti: PropTypes.bool,
  files: PropTypes.arrayOf(PropTypes.object),
  handleImagesChange: PropTypes.func,
  className: PropTypes.string
};

export default AddImage;
